import React from 'react';
import { splitDateTime, combineDateTime } from '../../../utils';

/**
 * DateTimeInput
 * Yan yana Tarih ve Saat seçici bileşeni.
 * - Tarih: <input type="date" />
 * - Saat: <input type="time" /> (opsiyonel)
 * - Değer 'YYYY-MM-DDTHH:mm' veya 'YYYY-MM-DD' olarak onChange ile bildirilir.
 */
const DateTimeInput = ({
  value = '',
  onChange,
  disabled = false,
  required = false,
  id
}) => {
  const { date, time } = splitDateTime(value);

  const handleDateChange = (e) => {
    const nextDate = e.target.value;
    if (!nextDate) {
      onChange('');
      return;
    }
    onChange(combineDateTime(nextDate, time));
  };

  const handleTimeChange = (e) => {
    const nextTime = e.target.value;
    onChange(combineDateTime(date, nextTime));
  };

  const handleClearTime = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onChange(combineDateTime(date, ''));
  };

  return (
    <div className="datetime-input-group">
      <input
        id={id}
        type="date"
        className="datetime-date-input"
        value={date}
        onChange={handleDateChange}
        disabled={disabled}
        required={required}
        title="Tarih"
      />
      <div className="datetime-time-wrapper">
        <input
          type="time"
          className="datetime-time-input"
          value={time}
          onChange={handleTimeChange}
          disabled={disabled}
          title="Saat (Opsiyonel)"
          placeholder="--:--"
        />
        {time && !disabled && (
          <button
            type="button"
            className="datetime-clear-time-btn"
            onClick={handleClearTime}
            title="Saati temizle"
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
};

export default React.memo(DateTimeInput);
